__turbopack_context__.v({
  "notice": "searchCorrectionNotice-module-scss-module__DtYr2a__notice",
});
